export default __webpack_public_path__ + "assets/7af0332fa8ce53380d83962ef2e64b17.svg";